export default __webpack_public_path__ + "static/vicedrop_inverse-ff8a615c57740fe144cf47b250fa71da.svg";